module.exports = __webpack_public_path__ + "static/media/shiftInfo.75e08eac.svg";